export var createInvalidModificationError = function createInvalidModificationError() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  try {
    return new DOMException(message, 'InvalidModificationError');
  } catch (err) {
    // @todo Edge is the only browser that does not yet allow to construct a DOMException.
    err.code = 13;
    err.message = message;
    err.name = 'InvalidModificationError';
    return err;
  }
};